(() => {
  const selector = document.querySelector('[data-mdf-language]');
  if (!selector) return;
  const form = selector.querySelector('form');
  // Section rendering must not become the destination after a language change.
  const setReturnPath = () => {
    const params = new URLSearchParams(location.search);
    params.delete('section_id');
    params.delete('sections');
    let returnTo = form.querySelector('input[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden'; returnTo.name = 'return_to'; form.append(returnTo);
    }
    returnTo.value = location.pathname + (params.size ? '?' + params.toString() : '');
  };
  setReturnPath();
  const buttons = [...form.querySelectorAll('button[name="language_code"]')];
  const available = buttons.map(button => button.value);
  const read = (storage, key) => { try { return storage.getItem(key); } catch { return null; } };
  const save = (storage, key, value) => { try { storage.setItem(key, value); } catch {} };
  let manual = null;
  let visited = null;
  try { manual = read(localStorage, 'mdf-language-choice'); } catch {}
  try { visited = read(sessionStorage, 'mdf-language-detected'); } catch {}
  form.addEventListener('submit', event => {
    setReturnPath();
    if (event.submitter?.name === 'language_code') {
      try { save(localStorage, 'mdf-language-choice', event.submitter.value); } catch {}
    }
  });
  document.addEventListener('click', event => { if (!selector.contains(event.target)) selector.open = false; });
  selector.addEventListener('keydown', event => {
    if (event.key === 'Escape') { selector.open = false; selector.querySelector('summary').focus(); }
  });
  if (selector.dataset.designMode === 'true' || /bot|crawler|spider|lighthouse/i.test(navigator.userAgent)) return;
  const localizedPath = buttons.some(button => button.value !== 'fr' && button.dataset.root && button.dataset.root !== '/' && (location.pathname === button.dataset.root || location.pathname.startsWith(button.dataset.root.replace(/\/$/, '') + '/')));
  if (localizedPath || (visited && !manual)) return;
  const match = value => available.find(code => code.toLowerCase() === value.toLowerCase()) || available.find(code => code.split('-')[0] === value.toLowerCase().split('-')[0]);
  const browserLanguage = (navigator.languages || [navigator.language]).map(match).find(Boolean);
  const countries = { FR:'fr', BE:'fr', CH:'fr', GB:'en', US:'en', IE:'en', CA:'en', AU:'en', ES:'es', IT:'it', NL:'nl', DE:'de', AT:'de', PT:'pt-PT', BR:'pt-PT' };
  const target = (available.includes(manual) && manual) || browserLanguage || match(countries[selector.dataset.country] || 'fr') || 'fr';
  try { save(sessionStorage, 'mdf-language-detected', '1'); } catch {}
  if (target === selector.dataset.current) return;
  const input = document.createElement('input');
  input.type = 'hidden'; input.name = 'language_code'; input.value = target;
  form.append(input);
  setReturnPath();
  HTMLFormElement.prototype.submit.call(form);
})();
